const sendWebSocketMessage = (
  queryString: string,
  message: string,
  messageType: string
) => {
//   console.log('queryString', queryString);
//   console.log('message', message);

  // Construct the base URL
  const baseURL =
    'wss://7cek3pd937.execute-api.us-east-2.amazonaws.com/production';

  // const baseURL = `wss://7cek3pd937.execute-api.us-east-2.amazonaws.com/${
  //   process.env.REACT_APP_DEPLOYMENT_ENVIRONMENT !== 'prod'
  //     ? 'test'
  //     : 'production'
  // }`;

  // Ensure the query string is attached correctly
  const url = `${baseURL}/?${queryString}`;

//   console.log('WebSocket URL:', url);

  const ws = new WebSocket(url);

  ws.onopen = async () => {
    // console.log('Connected to WebSocket.');
    // I need to send { "action": "sendmessage", "message": "Mike Kidby, Checked in at Q4 Impact" }
    const payload = {
      action: messageType,
      message,
    };
    await ws.send(JSON.stringify(payload));
  };
  // send the message then close the connection
  ws.onmessage = (event) => {
    // console.log('Message from server:', event.data);
    ws.close();
  };

  ws.onerror = (event) => {
    console.error('WebSocket error:', event);
  };

  ws.onclose = (event) => {
    if (event.wasClean) {
    //   console.log(
    //     `WebSocket closed cleanly, code=${event.code}, reason=${event.reason}`
    //   );
    } else {
      console.log('WebSocket closed unexpectedly.');
    }
  };
};

export default sendWebSocketMessage;
